import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=8245945a&scoped=true&"
import script from "./audit.vue?vue&type=script&lang=js&"
export * from "./audit.vue?vue&type=script&lang=js&"
import style0 from "./audit.vue?vue&type=style&index=0&id=8245945a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8245945a",
  null
  
)

export default component.exports